export default {
  groups: {
    display: 'grid',
    gridGap: '1em',
    marginTop: '30px'
  },
  groupsRadioHolder: {
    display: 'flex',
    marginTop: '10px'
  },
  groupsRadioRow: {
    marginTop: '30px'
  },
  groupRadio: {
    display: 'flex',
    alignItems: 'center',
    marginRight: '20px'
  },
  colorSelect: {
    width: '100px'
  }
}
